import {
	Button,
	Checkbox,
	DatePicker,
	Form,
	Switch,
	UploadFile,
	message,
} from 'antd'
import { AdminCModal } from 'app/components/Common'
import React, { useState } from 'react'
import { View } from 'styles/reactnative'
import {
	PopUpInputSection,
	PopUpTitleSection,
	PopUpWrapper,
} from '../../styles'
import SettingTitle from '../../SettingTitle'
import SettingInput from '../../SettingInput'
import PopUpModalHeader from './PopUpModalHeader'

import SettingMultiInput from './SettingMultiInput'
import PopUpImage from './PopUpImage'
import { awsUploadImage } from 'utils/awsImageStorage'
import { usePopUp } from 'app/hooks/AdminSettings/popUp'
import { anyTruthy } from 'utils/ExpensiveFunction'
import SettingTextarea from '../../SettingTextarea'
import SettingGroup from '../../SettingGroup'

const PopUpCreateModal = ({ showModal, setShowModal }) => {
	const [messageApi, contextHolder] = message.useMessage()

	const { createPopUp } = usePopUp()
	const [title, setTitle] = useState('')
	const [group, setGroup] = useState('0')
	const [content, setContent] = useState('')
	const [images, setImages] = useState<UploadFile[]>([])

	const [sizeWidth, setSizeWidth] = useState('')
	const [sizeHeight, setSizeHeight] = useState('')
	const [xAxis, setXAxis] = useState('')
	const [yAxis, setYAxis] = useState('')
	const [activate, setActivate] = useState(false)
	const [mobileUse, setMobileUse] = useState(false)
	const [startDate, setStartDate] = useState('')

	const [endDate, setEndDate] = useState('')

	const onFinish = async (values: any) => {
		if (anyTruthy(title, content)) {
			let cleanContent = content;
			if (content === '<p class="editor-paragraph"><br></p>' || content === '<p><br></p>') {
				cleanContent = '-';
			}
			
			await createPopUp({
				title,
				content: cleanContent,
				images: images || [],
				mobile: mobileUse,
				x: xAxis,
				y: yAxis,
				width: sizeWidth,
				height: sizeHeight,
				startdate: startDate,
				enddate: endDate,
				active: activate,
				group_id: group,
			})
			setTitle('')
			setGroup('0')
			setContent('')
			setSizeWidth('')
			setSizeHeight('')
			setXAxis('')
			setYAxis('')
			setImages([])
			setShowModal(!showModal)
		} else {
			messageApi.info('제목이나 내용을 추가해야 함')
		}
	}

	const onFinishFailed = (errorInfo: any) => {
		console.log('Failed:', errorInfo)
	}
	return (
		<AdminCModal width={850} show={showModal} setShow={setShowModal}>
			{contextHolder}
			<Form
				layout="vertical"
				style={{
					maxWidth: '100%',
					width: '100%',
					padding: 10,
					alignSelf: 'center',
					margin: 'auto',
				}}
				initialValues={{ remember: true }}
				onFinish={onFinish}
				onFinishFailed={onFinishFailed}
				autoComplete="off"
				size="middle">
				<PopUpModalHeader title={'구분'} content={'내용'} />
				<View
					style={{
						flexDirection: 'row',
						height: '100%',
						width: '100%',
					}}>
					<PopUpTitleSection style={{ borderRight: 0 }}>
						<SettingTitle title="타이틀" />
						<SettingTitle title="그룹" />
						<SettingTitle title="내용" style={{ height: 400 }} />
						<SettingTitle title="이미지" style={{ height: 130 }} />
						<SettingTitle title="사이즈" />
						<SettingTitle title="x위치" />
						<SettingTitle title="모바일사용" />
						<SettingTitle title="활성화" />
						<SettingTitle title="시작일" style={{ border: 0 }} />
						<SettingTitle title="종료일" style={{ border: 0 }} />
					</PopUpTitleSection>
					<PopUpInputSection>
						<SettingInput
							title={'타이틀'}
							value={title}
							setValue={setTitle}
						/>
						<SettingGroup
							title={'그룹설정'}
							group={group}
							setGroup={setGroup}
						/>
						<SettingTextarea
							title={'내용'}
							value={content}
							setValue={setContent}
							style={{ height: 400, width: '100%' }}
							update={false}
						/>
						<PopUpImage images={images} setImages={setImages} />
						<SettingMultiInput
							title={'가로'}
							content={'세로'}
							fValue={sizeWidth}
							setFValue={setSizeWidth}
							sValue={sizeHeight}
							setSValue={setSizeHeight}
						/>
						<SettingMultiInput
							title={'x값'}
							content={'y값'}
							fValue={xAxis}
							setFValue={setXAxis}
							sValue={yAxis}
							setSValue={setYAxis}
						/>

						<PopUpWrapper>
							<Checkbox
								checked={activate}
								onChange={e => {
									setActivate(e.target.checked)
								}}
							/>
						</PopUpWrapper>
						<PopUpWrapper>
							<Switch
								size="small"
								defaultChecked={mobileUse}
								onChange={checked => {
									setMobileUse(checked)
								}}
							/>
						</PopUpWrapper>
						<PopUpWrapper>
							<DatePicker
								format={'YYYY-MM-DD'}
								onChange={(date, dateString) => {
									setStartDate(dateString)
								}}
							/>
						</PopUpWrapper>
						<PopUpWrapper>
							<DatePicker
								format={'YYYY-MM-DD'}
								onChange={(date, dateString) => {
									setEndDate(dateString)
								}}
							/>
						</PopUpWrapper>
					</PopUpInputSection>
				</View>

				<View
					style={{
						marginTop: 10,
						width: '100%',
						flexDirection: 'row',
						justifyContent: 'space-between',
					}}>
					<Button
						onClick={() => {
							const t = encodeURIComponent(title)
							
							let cleanContent = content;
							if (content === '<p class="editor-paragraph"><br></p>' || content === '<p><br></p>') {
								cleanContent = '';
							}
							
							const c = encodeURIComponent(cleanContent)
							const i = encodeURIComponent(JSON.stringify(images))

							window.open(
								`/popup.html?title=${t}&content=${c}&images=${i}&height=${sizeHeight}&width=${sizeWidth}`,
								'_blank',
								`width=${sizeWidth},height=${sizeHeight},left=${xAxis},top=${yAxis}`
							)
						}}>
						미리보기
					</Button>
					<Button
						type="primary"
						htmlType="submit"
						style={{ width: '70%' }}>
						저장
					</Button>
				</View>
			</Form>
		</AdminCModal>
	)
}

export default PopUpCreateModal
